import { useContext, useMemo } from 'react';
import { Button } from '@leadsnavi/ui-kit';
import { Tooltip, TooltipContent, TooltipTrigger } from '@leadsnavi/ui-kit';
import Query1Icon from '@/assets/icons/query1.svg?react';

import { Input } from '@leadsnavi/ui-kit';
import BasePagination from '@/common/base/pagination';
import { SupplierTable } from './supplier-table';
import { useChatPageStore, useSupplierListStore } from '../../store';
import { useShallow } from 'zustand/shallow';
import { SupplierCardContext } from '../../store/supplier-card-context';
import CountrySelect from '@/common/base/country-select';
import { isString, upperFirst } from 'lodash-es';
import mixpanel from 'mixpanel-browser';
import { useMemoizedFn, useMount } from 'ahooks';
import { Search } from 'lucide-react';
import cn from 'classnames';
import styles from './supplier-list-page.module.scss';
import { ResultSummary } from './components/result-summary';
import { useConfirm } from '@/components/confirm-dialog';

export const CountryTip = () => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div>
          <Query1Icon className="" />
        </div>
      </TooltipTrigger>
      <TooltipContent className="max-w-[315px]">
        <p>Support filtering by the supplier's country</p>
      </TooltipContent>
    </Tooltip>
  );
};

export const SupplierListDetail = () => {
  const showListDetailSkeleton = useSupplierListStore(store => store.showListDetailSkeleton);
  const supplierTotal = useSupplierListStore(state => state.supplierListData?.total || 0);
  const setStoreState = useSupplierListStore(store => store.setStoreState);
  const {
    subMsgData,
    selectFilter,
    selectedCount,
    suppliers,
    pageInfo,
    onSearchChange,
    onSelectChange,
    onDetailClick,
    getSuppliersByDetailInit,
    handlePageChange,
    searchFilter,
    onSelectAllClick,
    isAiSummaryLoding,
    isKeywordLoading,
  } = useContext(SupplierCardContext);
  const selectSupplierInfo = useChatPageStore(useShallow(store => store.selectedSuppliers[subMsgData.subMessageId]));

  const confirm = useConfirm();

  const onSendInquiryClick = useMemoizedFn(async () => {
    // 旧的搜索卡片（SEARCH_CARD 类型）不再支持发送邀约，弹出提示弹窗通知用户
    await confirm({
      title: 'Action Unavailable',
      message: "New Inquiries can't be added to past tasks. Please create a new Request to proceed.",
      okText: 'Got it',
      cancelText: 'Cancel',
      showCancel: false,
    });
  });
  useMount(() => {
    getSuppliersByDetailInit();
  });
  const suppliersV2 = useMemo(() => {
    return showListDetailSkeleton ? [] : suppliers;
  }, [suppliers, showListDetailSkeleton]);
  return (
    <div
      className=" border-[color:var(--200-line-,#E5E5E5)] [background:#FFF] shadow-[20px_20px_50px_-12px_rgba(0,0,0,0.12)] rounded-xl border-[1.2px] border-solid size-full p-5
    flex flex-col
    "
    >
      <div className="flex justify-between items-center  mb-[22px]">
        <div>{upperFirst(subMsgData?.contentValue.queryProduct || '')} Recommended Suppliers</div>
        <span
          className="cursor-pointer"
          onClick={() => {
            setStoreState({
              showListDetailModal: false,
            });
          }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M6 6L18 18" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
      </div>

      {/* 搜索区域 */}
      <div className="flex justify-between items-center mb-[18px]">
        <div className=" flex items-center gap-3 grow mr-10">
          <CountrySelect
            value={searchFilter.country}
            className=" w-90 max-w-90  placeholder-[#737373]!"
            mode="multiple"
            size="smallMedium"
            placeholder="Select supplier country"
            onChange={value => {
              onSearchChange({
                country: isString(value) ? [value] : value,
              });
            }}
          />
          <div className={cn('flex items-center gap-1 ', styles.inputWrap)}>
            <Input
              placeholder="Product Detail"
              startSlot={<Search className="size-[20px]" />}
              startSlotCls="border-r-0 pl-3 pr-0 -mr-1"
              //暗文颜色 737373

              value={searchFilter.productDetail?.[0] || undefined}
              onChange={e => {
                onSearchChange({
                  productDetail: e.target.value ? [e.target.value] : undefined,
                });
              }}
            />
            <Tooltip>
              <TooltipTrigger asChild>
                <div>
                  <Query1Icon className="" />
                </div>
              </TooltipTrigger>
              <TooltipContent className="max-w-[315px]">
                <p>
                  Enter more detailed product information, such as model and serial numbers, for a more accurate search
                  experience
                </p>
              </TooltipContent>
            </Tooltip>
          </div>

          {/* <MultipleSelect
            value={searchSelectedLanguages}
            options={languageOptions || []}
            placeholder="language"
            className=" min-w-52"
            selectionMode="multiple"
            ellipsis={true}
            onChange={values => {
              onSearchChange({
                otherLanguages: values.map(splitLanguage),
              });
            }}
          /> */}
        </div>
        <Button
          size="sm"
          disabled={!selectSupplierInfo}
          id="inquiry_start_click"
          onClick={() => {
            onSendInquiryClick();
            mixpanel.track('inquiry_start_see_more');
            mixpanel.track('inquiry_start_click');
          }}
        >
          Send Inquiry
        </Button>
      </div>
      {/* 表格区域 */}
      <div className="h-auto  grow   overflow-hidden">
        <SupplierTable
          isKeywordLoading={isKeywordLoading}
          isAiSummaryLoding={isAiSummaryLoding}
          suppliers={suppliersV2}
          showSkeleton={showListDetailSkeleton}
          selectFilter={selectFilter}
          onSelectChange={onSelectChange}
          useFixedHeader={true}
          onDetailClick={onDetailClick}
          onSelectAllClick={onSelectAllClick}
        />
      </div>

      {/* 分页 */}
      <div className="flex justify-between items-center">
        <div className="text-[#262626] text-xs">
          <ResultSummary total={supplierTotal} selectedCount={selectedCount} />
        </div>
        <BasePagination
          page={pageInfo?.pageNo || 0}
          total={pageInfo?.totalCount || 0}
          pageSize={pageInfo?.pageSize || 0}
          showOnePage={true}
          onPageChange={page => handlePageChange(page)}
        />
      </div>
    </div>
  );
};
